import React from "react"
import { PlusOutlined, ImportOutlined, ScheduleOutlined } from "@ant-design/icons"

import { hasAccess } from "@components/Authorization"
import getConfig from "@components/Config/getConfig"

const LABEL_CREATE = "Create"
const LABEL_IMPORT = "Import"
const LABEL_SCHEDULE = "Schedule"
const SCHEDULE_DISTRIBUTIONS_ENABLED_ORG_IDS = getConfig("SCHEDULE_DISTRIBUTIONS_ENABLED_ORG_IDS")


const getHeaderActions = ({
  openCreateModal,
  openImportModal,
  openScheduleModal,
  selectableActions = [],
  isInvalidBankAccount = false,
  isSchedulesLoading = false,
  hasDistributionsAccount = false,
  organizationId,
}) => {
  const canCreateTransactions = hasAccess(['transactions-write'])

  const isScheduleDistributionsEnabledForOrganization =
    Array.isArray(SCHEDULE_DISTRIBUTIONS_ENABLED_ORG_IDS) &&
    SCHEDULE_DISTRIBUTIONS_ENABLED_ORG_IDS.length > 0 &&
    SCHEDULE_DISTRIBUTIONS_ENABLED_ORG_IDS.includes(organizationId)

  if (!canCreateTransactions) {
    return selectableActions
  }

  const isCreateButtonDisabled =
    !hasDistributionsAccount ||
    isInvalidBankAccount

  // NOTE: Transactions could be imported in the backfill mode, even if no bank
  //       account connected to the project.
  const isImportButtonDisabled =
    hasDistributionsAccount &&
    isInvalidBankAccount

  const items = []

  items.push({
    icon: <PlusOutlined />,
    title: LABEL_CREATE,
    action: openCreateModal,
    disabled: isCreateButtonDisabled,
  })

  items.push({
    icon: <ImportOutlined />,
    title: LABEL_IMPORT,
    action: openImportModal,
    disabled: isImportButtonDisabled
  })

  if (isScheduleDistributionsEnabledForOrganization) {
    items.push({
      icon: <ScheduleOutlined />,
      title: LABEL_SCHEDULE,
      action: openScheduleModal,
      disabled: isSchedulesLoading
    })
  }

  return [
    ...selectableActions,
    ...items,
  ]
}

export default getHeaderActions
